import { fetcher } from '@/src/general/utilities/fetcher'

export type TContactMessagePayload = {
  [key in 'email' | 'firstname' | 'lastname' | 'subject' | 'message']: string
} & {
  captchaV3?: string
  captchaV2?: string
}

export const contactApi = {
  sendContactMessage: (payload: TContactMessagePayload) =>
    fetcher.mutate<void, ReturnType<typeof formatPayload>>('/contact', formatPayload(payload), { method: 'POST' }),
}

const formatPayload = (payload: TContactMessagePayload) => ({
  ...payload,
  captcha: payload.captchaV2,
})
